import {Component, OnInit, ViewChild} from '@angular/core';
import { GenericModalService } from '../../../services/generic-modal.service';
import { PaginationInstance } from 'ngx-pagination';
import { WebClientConfigurationService } from '../../../services/configuration/web-client-configuration.service';
import {WfTableComponent} from '../../../common/table-sort/wf-table.component';
import {BsModalRef} from 'ngx-bootstrap/modal';
import {DriverService} from '../../../services/configuration/driver.service';

@Component({
  selector: 'app-driver-update-list',
  templateUrl: './driver-update-list.component.html',
  styleUrls: ['./driver-update-list.component.css']
})
export class DriverUpdateListComponent implements OnInit {

  onlyActive: boolean;
  driverList: any[];

  filterText: string;

  pleaseWait = false;
  isInstalling = false;
  errorMessage = '';
  config: PaginationInstance;
  @ViewChild(WfTableComponent, { static: false }) wfDataTable: WfTableComponent;

  constructor(
    private driverService: DriverService,
    private modalService: GenericModalService,
    private webClientConfig: WebClientConfigurationService, public bsModalRef: BsModalRef
  ) { }

  ngOnInit() {
    this.onlyActive = true;
    this.pleaseWait = true;
    this.errorMessage = '';
    this.driverService.getDriversForUpdate()
      .subscribe(list => {
          this.driverList = list;
          this.pleaseWait = false;
        },
        error => {
          this.errorMessage = error;
          this.pleaseWait = false;
        });
  }

  onChangelogClick(name, availableVersion) {
    this.errorMessage = '';
    this.driverService.getChangelog(name, availableVersion)
      .subscribe(result => {
          this.modalService.showMessage(result.changelog, true, undefined, 'Changelog do driver ' + name);
        },
        error => {
          this.errorMessage = error;
          this.pleaseWait = false;
        });
  }

  onInstallClick(driver: any) {
    driver.extensionData = null;
    this.pleaseWait = true;
    this.driverService.install(driver)
      .subscribe(result => {
          this.isInstalling = false;
          this.driverList = [];
          this.modalService.showSuccessMessage(`Driver ${driver.name} instalado com sucesso`, true, undefined);
          this.ngOnInit();
        },
        error => {
          this.modalService.showErrorMessage(`Erro ao tentar instalar o driver ${driver.name}: ${error}`, true);
          this.pleaseWait = false;
          this.isInstalling = false;
        });
  }
}
